import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { IJob } from '../models/IJob.model';
import { IJobAdd } from '../models/IJobAdd.model';

@Injectable()
export class JobService {

  constructor(private http: HttpClient) { }

  getJobs(userId: number): Observable<IJob[]> {
    return this.http.get<IJob[]>(`${environment.portalBase}jobs/get-for-user/${userId}`);
  }

  submitJob(job: IJobAdd): Promise<IJobAdd> {
    const formData = new FormData();

    formData.append('CompanyId', job.CompanyId.toString());
    formData.append('CompanyContactId', job.CompanyContactId.toString());
    formData.append('SysUserId', job.SysUserId.toString());
    formData.append('JobTitle', job.JobTitle);
    formData.append('JobLocation', job.JobLocation);
    formData.append('Note', job.Note);
    formData.append('IsAdmin', job.IsAdmin.toString());

    if (job.JobDescription) {
      formData.append('JobDescription', job.JobDescription);
    }

    if (job.CompensationTypeId) {
      formData.append('CompensationTypeId', job.CompensationTypeId.toString());
    }

    if (job.PositionTypeId) {
      formData.append('PositionTypeId', job.PositionTypeId.toString());
    }

    if (job.CompensationFromId) {
      formData.append('CompensationFromId', job.CompensationFromId.toString());
    }

    if (job.CompensationFrom) {
      formData.append('CompensationFrom', job.CompensationFrom.toString());
    }

    if (job.CompensationToId) {
      formData.append('CompensationToId', job.CompensationToId.toString());
    }

    if (job.CompensationTo) {
      formData.append('CompensationTo', job.CompensationTo.toString());
    }

    if (job.JobDescriptionFile) {
      formData.append('JobDescriptionFile', job.JobDescriptionFile);
    }

    return this.http
      .post<IJobAdd>(`${environment.portalBase}jobs/submit-job`, formData)
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/job.service.ts